import * as React from 'react';

const arrowMeter = (props: any) => {
  const { colorPrimary } = props;

  return (
    <>
      <path
        d="M5 95L95 5M5 5H95V95"
        stroke={colorPrimary}
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  );
};
export default arrowMeter;
